import React from "react";
import Button from "../button";

const VideoModal = ({ data }) => {
  return (
    <section className="relative  flex flex-col items-center justify-center lg:p-36 xxl:p-56 py-36 overflow-hidden">
      <div className="w-full relative  max-w-screen-xl xxl:max-w-screen-3xl z-30 text-2xl text-white bg-purple-300 bg-opacity-50 rounded-xl">
        <div className=" rounded-xl bg-white py-10 px-6 w-[93%] lg:w-[500px] self-center m-auto lg:m-0 opacity-80">
          <h2 className="lg:text-5xl text-2xl font-bold text-teal tracking-[-0.055em]  leading-[48px] lg:leading-[60px]">
            {data.Title}
          </h2>
          <p className=" text-lg font-normal text-black mb-6 tracking-[-0.055em] ">
            {data.PlainText}
          </p>

          {data.Button?.ShowButton && <Button data={data.Button} />}
        </div>
      </div>
      <video
        autoPlay={true}
        loop
        muted
        className="absolute z-10 w-auto min-w-full min-h-full max-w-none"
        id="myVideo"
      >
        <source
          src={`${process.env.GATSBY_STRAPI_API_URL}${data.Media.url}`}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    </section>
  );
};

export default VideoModal;
